module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/quickstart-optimistic-step-1.json
// module id = 2361
// module chunks = 68367335468643